<template>
  <div>
    
    <Link :href="href" >
        {{rowValue}}
    </Link>
  </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: {
        cellData: {
            type: Object,
            default: () => {},
        },
        mRoute: String,
        rPrifix: String
    },
    data: function ()
    {
        return {
            rowValue:"",
            href:route(this.mRoute + ".show", [this.rPrifix,this.cellData.data.id]),
        }
    },
    mounted() {

        if (this.cellData.value) {
        // 👇️ this runs
            this.rowValue = this.cellData.value;
        }
        
        
    }
}
</script>

<style>

</style>